import dataFilter from 'echarts/lib/processor/dataFilter';
import { EChartsExtensionInstallRegisters } from 'echarts/types/src/extension';
import dvRadarSeries from './radarSeriesModel';
import dvRadarView from './DvRadarView';
import dvRadarLayoutFunc from './radarLayout';
import backwardCompat from './backwardCompat';
import { installRadarAction } from './radarAction';

export function install(registers: EChartsExtensionInstallRegisters) {
  installRadarAction(registers);
  registers.registerChartView(dvRadarView);
  registers.registerSeriesModel(dvRadarSeries);

  registers.registerLayout(dvRadarLayoutFunc);
  registers.registerProcessor(dataFilter('radar'));

  // 注册预处理，处理极坐标和顺时针轴
  registers.registerPreprocessor(backwardCompat);
}
